import { Injectable } from '@angular/core';
import { AnimationHelper } from 'src/app/helpers/animation.helper';
import { IModalDialog } from 'src/app/interfaces/ux/modal-dialog.interface';

@Injectable({
  providedIn: 'root'
})
export class DialogService {
  private modals: IModalDialog[] = [];

  constructor() {
  }

  get hasModals() {
    return this.modals.length > 0;
  }

  get visibleModals() {
    return this.modals;
  }

  get currentModal() {
    return this.visibleModals[this.visibleModals.length - 1];
  }

  get modalElement() {
    return this.getModalElement(this.currentModal.id);
  }

  private getModalElement(id) {
    return document.getElementById(`modal_${id}`);
  }

  async closeModal(id?: string) {
    if (!id) {
      await AnimationHelper.animate(this.modalElement, "fadeOutUpBig");
      this.modals.pop();
    }
    else {
      const element = this.getModalElement(id);
      if (element) {
        await AnimationHelper.animate(element, "fadeOutUpBig");
      }
      this.modals.splice(this.modals.findIndex(m => m.id === id), 1);
    }
  }

  show(modal: IModalDialog): string {
    modal.id = modal.id || (new Date().getTime() + "");
    this.modals.push(modal);

    return modal.id;
  }

  showAndWait(modal: IModalDialog): Promise<number> {
    return new Promise<number>((resolve) => {
      const originalCb = modal.cb;
      const cb = (result: number) => {
        if (originalCb) {
          setTimeout(() => originalCb(result), 1);
        }

        resolve(result);
      };

      modal.id = modal.id || (new Date().getTime() + "");
      modal.cb = cb;

      this.modals.push(modal);
    });
  }

  async error(message: string, title = "Error") {
    await this.showAndWait({
      title,
      message,
      okButton: "Dismiss",
      type: "danger",
      cb: null
    });
  }
}
